import React from 'react';
import { Box, HStack, useColorModeValue, Text, Flex, IconButton, useBreakpointValue, Image, Menu, MenuButton, MenuList, MenuItem, Avatar, Spacer, Select } from '@chakra-ui/react';
import { Link as RouterLink } from 'react-router-dom';
import { useProjectContext } from '../context/ProjectContext';
import { useUser } from '../context/UserContext';
import { FaBars } from 'react-icons/fa';

export default function Header({ onOpenMenu }) {
  const bg = useColorModeValue('white', 'gray.50');
  const border = useColorModeValue('gray.200', 'gray.200');
  const textColor = useColorModeValue('gray.800', 'gray.100');
  const isMobile = useBreakpointValue({ base: true, md: false });
  const { projects, loading, selectedProject, setSelectedProject } = useProjectContext();
  const { user } = useUser();

  return (
    <Flex
      as="header"
      w="100%"
      bg={bg}
      borderBottomWidth={1}
      borderColor={border}
      borderRadius="xl"
      px={{ base: 4, md: 8 }}
      py={3}
      position="fixed"
      top={0}
      left={0}
      zIndex={110}
      align="center"
      minH="64px"
      gap={6} 
    >
      {/* Left: Logo and App Name */}
      <HStack spacing={3} minW={{ base: 'auto', md: '220px' }}>
        <Box boxSize={9} borderRadius="lg" bg={useColorModeValue('gray.100', 'gray.700')} p={1} display="flex" alignItems="center" justifyContent="center">
          <Image src="/logo512.png" alt="WP QA Testing Dashboard" objectFit="contain" w="100%" h="100%" />
        </Box>
        {!isMobile && (
          <Text fontWeight="bold" fontSize="lg" color={textColor} letterSpacing="-0.5px">WP QA Testing Dashboard</Text>
        )}
      </HStack>
      {/* Optional: Project selector placeholder (hidden on mobile) */}
      <Spacer />
      {!isMobile && (
        <Select
          maxW="240px"
          size="sm"
          bg="white"
          borderColor={border}
          aria-label="Project selector"
          value={selectedProject || 'ALL PROJECTS'}
          onChange={(e) => setSelectedProject(e.target.value)}
          isDisabled={loading}
        >
          <option value="ALL PROJECTS">All Projects</option>
          {projects.map((p) => (
            <option key={p.id || p} value={p.id || p}>
              {p.name || p}
            </option>
          ))}
        </Select>
      )}

      {/* Right: User menu and mobile menu button */}
      <HStack spacing={2}>
        {!isMobile && (
          <Menu>
            <MenuButton 
              as={Avatar} 
              name={user?.name || 'User'} 
              src={user?.avatarUrl}
              size="sm" 
              cursor="pointer"
              bg={user?.avatarUrl ? undefined : "orange.400"}
              color="white"
            />
            <MenuList>
              <MenuItem as={RouterLink} to="/profile">Profile</MenuItem>
              <MenuItem as={RouterLink} to="/settings">Settings</MenuItem>
              <MenuItem>Sign out</MenuItem>
            </MenuList>
          </Menu>
        )}
        {isMobile && (
          <IconButton
            icon={<FaBars />}
            aria-label="Open menu"
            variant="ghost"
            borderRadius="xl"
            onClick={onOpenMenu}
          />
        )}
      </HStack>
    </Flex>
  );
} 